// Composant pour afficher un champ dans la barre latérale
import React from 'react'
import styles from './SidebarField.module.css'

function SidebarField(props) {
  const { field, overlay } = props
  const { title, SvgImage, SvgBackgroundColor, SvgColor, details } = field
  const className = `${overlay ? styles.overlay : ''}`

  return (
    <div className={styles.block}>
      <div className={styles.image__item}>
        <div className={styles.svg__image}>{SvgImage && <SvgImage />}</div>
      </div>
      <div className={styles.title}>{title}</div>
    </div>
  )
}

export default SidebarField
